import { useIsSignedIn } from "PFApp/hooks";
import { shouldShowTerms } from "PFApp/routes/utils";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { useCurrentProfile, useCurrentProfileUpdate } from "PFCore/hooks/queries/profile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { TermsOfService } from "../components/terms_of_service";

export const TermsOfServicePage = () => {
  const { isSignedIn } = useIsSignedIn();
  return isSignedIn ? <TermsOfServiceAcceptable /> : <TermsOfService />;
};

const TermsOfServiceAcceptable = () => {
  const { t } = useTranslation("onboarding");
  const { mutateAsync: updateCurrentProfile } = useCurrentProfileUpdate();

  const { showGrowl } = useGrowlStoreActions();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { data: currentAccount } = useCurrentAccount();
  const { data: currentProfile } = useCurrentProfile();

  const shouldAcceptTerms = shouldShowTerms(currentAccount, currentProfile);

  useEffect(() => {
    if (shouldAcceptTerms) {
      showGrowl({ message: t("termsOfService.acceptPrompt") });
    }
  }, [shouldAcceptTerms]);

  const handleAcceptTerms = () => {
    setLoading(true);
    updateCurrentProfile({ agreeToTermsAndConditions: true })
      .then(() => {
        setLoading(false);
        showGrowl({ message: t("termsOfService.accepted") });
        navigate("/");
      })
      .catch(() => {
        setLoading(false);
        showGrowl({ kind: "error", message: t("termsOfService.error") });
      });
  };

  return shouldAcceptTerms ? (
    <TermsOfService showAccept onAccept={handleAcceptTerms} acceptDisabled={loading} />
  ) : (
    <TermsOfService />
  );
};
